import { VehicleInformationSocketDto } from '../dto'
import { VehicleInformationSocketModel } from '../models'

/**
 * Transform vehicle information data from socket dto to model.
 */
export const transformVehicleInformationSocketDtoToModel = (dto: VehicleInformationSocketDto[]): VehicleInformationSocketModel[] => {
  const vehicleInformationModel = dto.map(information => {
    const { installationId, wallboxId, sessionId, vehicleId, vehicle, activeSchedule, targetStateOfCharge } = information ?? {}
    const { vehicleState, vehicleName, customName } = vehicle ?? {}
    const { chargingState, estimatedRange, stateOfCharge, chargeLimitMin, chargeLimitMax, isOnline, chargingTimeRemaining } = vehicleState ?? {}

    return {
      installationId,
      wallboxId,
      sessionId,
      vehicleId,
      chargingState,
      estimatedRange,
      vehicleName,
      customName: customName ?? undefined,
      activeSchedule: activeSchedule ?? undefined,
      targetStateOfCharge: targetStateOfCharge ?? undefined,
      stateOfCharge,
      chargeLimitMin: chargeLimitMin ?? undefined,
      chargeLimitMax: chargeLimitMax ?? undefined,
      isOnline,
      chargingTimeRemaining,
    }
  })

  return vehicleInformationModel
}
